/** Display helpers for trainer demo → enrollment ranking rows. */

import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import {
  trainerAttendedUrl,
  trainerEnrolledUrl,
  trainerClosedUrl,
} from './leadListDeepLinks';

function StatLink({ to, children }) {
  if (!to) return <>{children}</>;
  return (
    <Link
      component={RouterLink}
      to={to}
      underline="hover"
      color="primary"
      onClick={(e) => e.stopPropagation()}
      sx={{ fontWeight: 500 }}
    >
      {children}
    </Link>
  );
}

export function trainerRankingLine1(row, { period } = {}) {
  const demos = row.demosCompleted ?? 0;
  const attended = row.attended ?? 0;
  const enrolled = row.enrollments ?? 0;
  if (!period || !row.teacherId) {
    return `${demos} Demos · ${attended} Attended · ${enrolled} Enrolled`;
  }
  return (
    <>
      {demos} Demos ·{' '}
      <StatLink to={trainerAttendedUrl(period, row.teacherId)}>{attended} Attended</StatLink>
      {' · '}
      <StatLink to={trainerEnrolledUrl(period, row.teacherId)}>{enrolled} Enrolled</StatLink>
    </>
  );
}

export function trainerRankingLine2(row) {
  return `Conversion: ${row.conversionPct ?? 0}%`;
}

export function trainerRankingDemoTrialLine(row, { period } = {}) {
  const attendedDemo = row.attendedDemo ?? 0;
  const enrolledDemo = row.enrollmentsDemo ?? 0;
  const attendedTrial = row.attendedTrial ?? 0;
  const enrolledTrial = row.enrollmentsTrial ?? 0;
  if (!period || !row.teacherId) {
    return `Demo: ${attendedDemo} attended · ${enrolledDemo} enrolled · Trial: ${attendedTrial} attended · ${enrolledTrial} enrolled`;
  }
  return (
    <>
      Demo:{' '}
      <StatLink to={trainerAttendedUrl(period, row.teacherId, 'demo')}>{attendedDemo} attended</StatLink>
      {' · '}
      <StatLink to={trainerEnrolledUrl(period, row.teacherId, 'demo')}>{enrolledDemo} enrolled</StatLink>
      {' · Trial: '}
      <StatLink to={trainerAttendedUrl(period, row.teacherId, 'trial')}>{attendedTrial} attended</StatLink>
      {' · '}
      <StatLink to={trainerEnrolledUrl(period, row.teacherId, 'trial')}>{enrolledTrial} enrolled</StatLink>
    </>
  );
}

export function trainerRankingClosedLabel(row, { period } = {}) {
  const closed = row.enrollmentsClosedInPeriod ?? 0;
  const pct = row.conversionClosedInPeriodPct ?? 0;
  if (!period || !row.teacherId) {
    return `Closed this month: ${closed} enrolled · ${pct}%`;
  }
  return (
    <>
      Closed this month:{' '}
      <StatLink to={trainerClosedUrl(period, row.teacherId)}>{closed} enrolled</StatLink>
      {` · ${pct}%`}
    </>
  );
}
